import { VaultFile } from "../../../../models/data/blobby/vault-file.data";
import { VaultFileStoreModel } from "../../../../models/store/vault-file.store.model";

type VaultFileModelV1 = Omit<VaultFileStoreModel, "v" | "fs" | "sai" | "ob" | "cb"> & {
  sa: string[];
  v: 1;
};

type VaultFileModelV2 = Omit<VaultFileModelV1, "v" | "sa"> & {
  sai: string[];
  v: 2;
  fs: number;
};

export const vaultFile_v0_to_v1 = (vaultItem: VaultFile): VaultFileModelV1 => {
  return {
    stat: vaultItem.status,
    dm: new Date().toString(),
    dc: new Date().toString(),
    encK: vaultItem.encryptedKey,
    id: vaultItem.id,
    mt: vaultItem.mimeType,
    nm: vaultItem.name,
    sa: vaultItem.statementAccounts,
    sfd: vaultItem.statementFromDate.date,
    std: vaultItem.statementToDate.date,
    v: 1,
    vid: "",
  };
};

export const vaultFile_v1_to_v2 = (vaultItem: VaultFileModelV1): VaultFileModelV2 => {
  return {
    sai: vaultItem.sa,
    v: 2,
    fs: 0,
    stat: vaultItem.stat,
    dm: vaultItem.dm,
    dc: vaultItem.dc,
    encK: vaultItem.encK,
    id: vaultItem.id,
    mt: vaultItem.mt,
    nm: vaultItem.nm,
    sfd: vaultItem.sfd,
    std: vaultItem.std,
    vid: vaultItem.vid,
  };
};

export const vaultFile_v2_to_v3 = (vaultItem: any): VaultFileStoreModel => {
  return {
    ...vaultItem,
    ob: 0,
    cb: 0,
    v: 3,
  };
};
